'use client';

import { Button } from '@/components/ui/button';
import { useNetworkStatus } from '@/hooks/use-network-status';
import { cn } from '@/lib/utils';
import { RotateCw, WifiOff } from 'lucide-react';

export function OfflineStatusIndicator() {
  const isOnline = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-3 z-[100] flex justify-center px-2 sm:px-3"
      role="status"
      aria-live="polite"
    >
      <div
        className={cn(
          'pointer-events-auto flex h-10 max-w-[calc(100vw-1rem)] items-center gap-2 rounded-full',
          'border-border/70 bg-background/95 text-foreground border px-2 shadow-sm shadow-black/10 backdrop-blur-xl',
          'supports-[backdrop-filter]:bg-background/80 dark:border-white/10 dark:bg-black/70'
        )}
      >
        <span className="bg-destructive/10 text-destructive flex size-7 shrink-0 items-center justify-center rounded-full">
          <WifiOff className="size-3.5" aria-hidden="true" />
        </span>
        <div className="min-w-0 text-sm leading-none whitespace-nowrap">
          <span className="font-medium">Offline</span>
          <span className="text-muted-foreground ml-1 hidden sm:inline">
            Reconnecting...
          </span>
        </div>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="ml-1 h-7 rounded-full px-2.5 text-xs shadow-none"
          onClick={() => window.location.reload()}
        >
          <RotateCw className="size-3.5" aria-hidden="true" />
          <span className="hidden sm:inline">Retry</span>
        </Button>
      </div>
    </div>
  );
}
